import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IEmployeeWorkgroupState } from './employee-workgroup.types';
import { IEmployeeWorkgroupData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IEmployeeWorkgroupState = {
  version: 1,
  employeeWorkgroups: [] as IEmployeeWorkgroupData[]
};

const namespaced = true;

export const employeeWorkgroup: Module<IEmployeeWorkgroupState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
